/**
 * **Narration notes** riding a resolution's `warnings` list: a line that says what happened rather
 * than warning about it (`Berserker · Aggression: no one adjacent, no attack`, `combat-surface-polish`
 * 7.1). One invisible mark at the front tells a renderer to draw it as a plain muted line instead of
 * an advisory. It travels in `warnings` so every path that already carries warnings (the resolver's
 * merges, the wire, the persisted feed) carries notes unchanged.
 */
const NOTE_MARK = "⁣";

/** Mark `text` as a narration note. */
export function resolutionNote(text: string): string {
  return NOTE_MARK + text;
}

/** Split a warnings list into the real advisories and the notes' plain text, each in order. */
export function splitResolutionNotes(lines: readonly string[]): { warnings: string[]; notes: string[] } {
  const warnings: string[] = [];
  const notes: string[] = [];
  for (const line of lines) {
    if (line.startsWith(NOTE_MARK)) notes.push(line.slice(NOTE_MARK.length));
    else warnings.push(line);
  }
  return { warnings, notes };
}
